<template>
  <!--<sweet-modal ref="adminModal" @close="closeModal" :width="modalWidth">
    <component :is="modalItem.type"
               :data="modalItem.value"
               class="lp-modal-wrapper"></component>
  </sweet-modal>-->
  <modal name="adminModal" ref="modal"
         :adaptive="true"
         height="auto"
         :width="modalWidth"
         @closed="closeModal"
         :clickToClose="modalItem.background"
         class="modal-style">
    <component :is="modalItem.type"
               :data="modalItem.value"
               class="lp-modal-wrapper"></component>
  </modal>
</template>

<script>
  export default {
    data () {
      return {
        // modalItem 데이터
        // background: 백그라운드 클릭시 닫히게 하는 여부 ( true, false )
        // type: modal component 이름
        // value: modal component로 전달할 데이터
        // width: 모달의 width 크기
        modalItem: '',
        modalWidth: 600,
      }
    },
    created() {
      this.$store.commit('closeModal');
    },
    watch:{
      modalStatus(n){
        if(n === 'open'){
          //this.$refs.adminModal.open();
          this.modalItem = this.$store.getters.modalItem;
          let width = this.getWidth();
          if(width) {
            this.modalWidth = width;
            this.$refs.modal.modal.width = width;
          }
          if(this.modalItem) {
            this.$modal.show('adminModal');
          }
        }
        else if(n === 'close') {
          //this.$refs.adminModal.close();
          this.$modal.hide('adminModal');
          this.$store.commit('closeModal');
        }
        else if(n === 'cancel') {
          //this.$refs.adminModal.close();
          this.$modal.hide('adminModal');
          this.$store.commit('cancelModal');
        }
      }
    },
    methods: {
      getWidth(){
        if(this.$store.getters.device==='pc'){
          if(this.modalItem.width) {
            return this.modalItem.width;
          }
          else {
            return null;
          }
        }
        else {
          return null;
        }
      },
      closeModal(){
        this.$store.commit('cancelModal');
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  #header
  #body
  #bottom
    padding 24px

  .sweet-modal
    max-width 90%
    max-height 90vh
</style>
